module.exports = __webpack_public_path__ + "46fd5870378a6a12d88b9ae9e10ca1f4.MP3";